package pwgs.ui.scenes.generalsettingsscene


class GeneralSettingsControllerFe(props: GeneralSettingsSceneProps, scene: MGeneralSettingsScene) : AGeneralSettingsControllerFe(props, scene) {

    override fun createInitialModel() : GeneralSettingsSceneModel {
        return GeneralSettingsSceneModel("", "")
    }

    override fun init() {
        call_load()
    }


}

